import { getEnvKey } from '../../../constants/envs';
import { tracer } from '../tracers';

/**
 * Creates a root OpenTelemetry span for the Ezlogic application session.
 *
 * @returns {import('@opentelemetry/api').Span} The created OpenTelemetry Span representing the application root/session.
 *
 * @example
 * const appRootSpan = createAppRootSpan();
 * // ...attach children spans as needed
 * appRootSpan.end();
 */
export function createAppRootSpan() {
    const environment = getEnvKey();

    return tracer.startSpan(`Ezlogic application session`, { attributes: { environment } });
}
